import {
  SET_GYM_DASHBOARD_CARD_DATA,
  SET_GYM_DASHBOARD_LIVE_DATA,
  SET_BOOKINGS,
  SET_SALES,
  SET_EXPANSION_COUNT,
  SET_EXPANSION_SUMMARY
} from "../../actions/types/types";

const initState = {
  cardData: {},
  liveClassCardData: {},
  bookings: [],
  sales: [],
  expansionCount: "",
  expansionSummary: {},
  dashboardWeeklySchedule:null,
  dashboardCharts:undefined,
};

const GymDashboardReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_GYM_DASHBOARD_CARD_DATA:
      return {
        ...state,
        cardData: action.payload.data
      };
    case SET_GYM_DASHBOARD_LIVE_DATA:
      return {
        ...state,
        liveClassCardData: action.payload.data
      };
    case "SET_DASHBOARD_WEEKLY_SCHEDULE":
      return {
        ...state,
        dashboardWeeklySchedule: action.payload.data
      };
    case SET_BOOKINGS:
      return {
        ...state,
        bookings: action.payload.data
      };
    case SET_SALES:
      return {
        ...state,
        sales: action.payload.data
      };
    case SET_EXPANSION_COUNT:
      return {
        ...state,
        expansionCount: action.payload.data
      };
    case SET_EXPANSION_SUMMARY:
      return {
        ...state,
        expansionSummary: action.payload.data
      };
    case "SET_DASHBOARD_CHARTS":
      return {
        ...state,
        dashboardCharts: action.payload.data
      };
    default:
      return { ...state };
  }
};

export default GymDashboardReducer;
